export default "__VITE_ASSET__DF8L3iDl__"